import { FunctionComponent } from 'react'

import { isHTML } from '@/utils/thmlUtls'

import { TextHTML } from '@/components/typography'

import { TListWithIconsProps } from './types'

export const ListWithIcons: FunctionComponent<TListWithIconsProps> = ({
  className,
  mainTitle,
  pageDescription,
  items,
  itemsF,
}: TListWithIconsProps) => {
  const htmlRegex = mainTitle && isHTML(mainTitle)

  return (
    <div className={className}>
      {mainTitle && (
        <>
          {htmlRegex ? (
            <div className="main-title" dangerouslySetInnerHTML={{ __html: mainTitle }}></div>
          ) : (
            <div className="main-title">{mainTitle}</div>
          )}
        </>
      )}

      {pageDescription && (
        <div
          className="main-description"
          dangerouslySetInnerHTML={{ __html: pageDescription }}
        ></div>
      )}
      {(items || (itemsF && itemsF()) || []).map((item) => {
        const title = typeof item.title === 'string' ? item.title : item.title()
        const description =
          typeof item.description === 'function' ? item.description() : item.description
        return (
          <div className="item" key={item.id}>
            {item.iconNode && (
              <div className="icon-node-container">
                {typeof item.iconNode === 'object' && 'src' in item.iconNode ? (
                  <img src={item.iconNode.src} alt="" loading="lazy" />
                ) : (
                  item.iconNode
                )}
              </div>
            )}
            <div className="item-content-container">
              <TextHTML className="text" title={title} />
              {description && <TextHTML className="description" title={description} />}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export type { TListWithIconsProps }
